import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Compass, Phone, Mail, MapPin, Send, Heart, Facebook, Instagram, Twitter, Youtube } from 'lucide-react';
import './Footer.css';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email.trim()) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 5000);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-top container">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <Compass className="logo-icon" />
            <span>Holiday<span className="logo-accent">Kart</span></span>
          </Link>
          <p className="footer-desc">
            Crafting unforgettable travel memories. We design premium customized tours and holiday packages that cater to your dream getaways.
          </p>
          <div className="footer-contact">
            <div className="contact-item">
              <Phone size={16} />
              <span>+91 92962 06555</span>
            </div>
            <div className="contact-item">
              <Mail size={16} />
              <span>@holidaykartofficial@gmail.com</span>
            </div>
            <div className="contact-item">
              <MapPin size={16} />
              <span>Hyderabad, Telangana, India</span>
            </div>
          </div>
          <div className="footer-socials">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <Facebook size={18} />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <Instagram size={18} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <Twitter size={18} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="Youtube">
              <Youtube size={18} />
            </a>
          </div>
        </div>

        <div className="footer-links-grid">
          <div className="footer-links-col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/domestic">Domestic Tours</Link></li>
              <li><Link to="/international">International Tours</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-links-col">
            <h4>Popular Spots</h4>
            <ul>
              <li><Link to="/tour/swiss-alps-paradise">Swiss Alps</Link></li>
              <li><Link to="/tour/maldives-escape">Maldives Resort</Link></li>
              <li><Link to="/tour/kerala-experience">Kerala Backwaters</Link></li>
              <li><Link to="/tour/leh-ladakh-adventure">Ladakh Adventure</Link></li>
              <li><Link to="/tour/bali-culture-beach">Bali Tropics</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-newsletter">
          <h4>Newsletter</h4>
          <p>Subscribe to receive exclusive travel offers and itinerary releases.</p>
          <form className="newsletter-form" onSubmit={handleSubscribe}>
            <input
              type="email"
              className="form-control"
              placeholder="Your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="btn btn-primary btn-icon" aria-label="Subscribe">
              <Send size={16} />
            </button>
          </form>
          {subscribed && <span className="newsletter-success">Subscribed successfully! Check your inbox soon.</span>}
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content container">
          <p className="copy-text">&copy; {new Date().getFullYear()} Holiday Kart. All rights reserved.</p>
          <p className="made-text">
            Made with <Heart size={14} className="heart-icon" /> for travelers worldwide.
          </p>
        </div>
      </div>
    </footer>
  );
}
